import Vue from 'vue'
import router from './router'
import App from './App.vue'
import filter from './filter'
import api from './api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


const preventReClick =  Vue.directive('dbClick', {
    inserted(el, binding) {
        el.addEventListener('click', e => {
            if (!el.disabled) {
                el.disabled = true
                el.style.cursor = 'not-allowed'
                setTimeout(() => {
                    el.style.cursor = 'pointer'
                    el.disabled = false
                }, 1500)
            }
        })
    }
})


Vue.use(preventReClick)

Vue.use(ElementUI);

Vue.prototype.confirmBox = async (msg,confirm,cancel) =>{//确定提示框
    try{
        await Vue.prototype.$confirm(msg,'提示',{confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'});
        confirm && confirm();
    }catch (e){
        console.log(e);
        cancel && cancel();
    }
}

Vue.prototype.beforeUpload = file => {
    const isJPG = file.type === 'image/jpeg';
    // const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
        Vue.prototype.$notify({ message: `上传头像图片只能是 JPG 格式!`, type: 'error'});
    }
    // if (!isLt2M) {
    //     Vue.prototype.$notify({ message: `上传头像图片大小不能超过 2MB!`, type: 'error'});
    // }
    return isJPG;
}

Vue.prototype.api = api;

Vue.prototype.baseURL = window.config.baseURL;

Vue.prototype.uploadUrl = window.config.uploadUrl;

Vue.prototype.getUploadFileUrl = window.config.getUploadFileUrl;

Vue.prototype.base64Img = (file)=>{
    return new Promise(function(resolve, reject) {//使用Promise进行异步处理
        let reader = new FileReader();                  //实例化一个对象
        reader.readAsDataURL(file);                     //把图片文件对象转换base64
        reader.onload = e => resolve(e.target.result)   //回调函数返回base64值
    })
}

Vue.prototype.waitSomeTime = ms => new Promise(resolve => setTimeout(resolve),ms);

Vue.prototype.gradeMap = window.config.gradeMap;

Vue.prototype.getGradeName = grade => {
    let gradeMap = window.config.gradeMap;
    return gradeMap[grade] ? gradeMap[grade] : '未知';
}

Array.prototype.getIndexById = function(id){//从数组中删除某值By Id
    for(let i=0; i<this.length; i++) {
        if(this[i].id == id) {
            return i;
        }
    }
    return -1;
}

for(let p in filter){//遍历对象属性，加载所有方法到filter
    Vue.filter( p ,filter[p]);
}

let vm = new Vue({
    el: '#app',
    router,
    render: h => h(App),
})

export default vm//导出这个实例
